import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const exportTableData = async (data) => (
  axiosRequest({
    data,
    url: '/v1/docs/export/table',
    method: 'POST',
    headers: defaultHeaders,
  })
);

const exportChartData = async (data) => (
  axiosRequest({
    data,
    url: '/v1/docs/export/chart',
    method: 'POST',
    headers: defaultHeaders,
  })
);

const exportFile = async (data) => (
  axiosRequest({
    data,
    url: '/v1/docs/export/file',
    method: 'POST',
    headers: defaultHeaders,
  })
);

const importManualData = async (data) => (
  axiosRequest({
    data,
    url: '/v1/docs/import/manual',
    method: 'POST',
  })
);

const importAutoData = async (data) => (
  axiosRequest({
    data,
    url: '/v1/docs/import/auto',
    method: 'POST',
  })
);

export {
  importManualData,
  importAutoData,
  exportTableData,
  exportChartData,
  exportFile,
};
